// extracted by mini-css-extract-plugin
export default {"button":"PaginationButton_button__6DCzf","btnDisabled":"PaginationButton_btnDisabled__0yVtc","ml":"PaginationButton_ml__-8l5U","mr":"PaginationButton_mr__AtkwK"};